exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#cgv{font-size:11px;font-style:italic;color:#3f3f3f;margin-bottom:25px}#recap>ul>div>p,#recap>ul>p{margin-bottom:10px}#finish #recap ul{border-top:1px solid #999;padding:10px 0}#finish #recap ul:last-child{border-bottom:1px solid #999;margin-bottom:20px}#finish #recap ul li{margin-bottom:10px}#finish #recap ul li.floating p{width:50%;float:left}#finish #recap ul li p{color:#666;font-size:1.2rem;font-weight:400}#finish #recap ul li strong{color:#000;font-size:1.5rem;font-weight:700}li>pre{background-color:#f1f1f1;border-radius:6px;padding:10px;color:#666;font-size:1.2rem;font-weight:400;margin-top:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47f24d92","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/fiches/bsdd/subcomponents/Recap.vue
// module id = 630
// module chunks = 0